import Grid from '@mui/material/Grid'
import TextField from '@mui/material/TextField'
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import MobileStepper from '@mui/material/MobileStepper';
import Slider from '@mui/material/Slider';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import InputAdornment from '@mui/material/InputAdornment';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../../interface/ApplicationState';
import { updateLocalUser } from '../../redux/actions/userActions';
import { alpha, Box, Divider, Typography, useTheme } from '@mui/material';
import { styles } from '../Settings';

export const ProfitConfiguration = () =>
{
  const dispatch = useDispatch();
  const user = useSelector((state: ApplicationState) => state.userStore.user)
  const theme = useTheme()

  return(
    <Card sx={localStyles.card(theme)}>
          <Typography variant="body2" sx={localStyles.copy(theme)}>
            Configure how the bot locks in gains, when profits should be taken automatically, and whether winnings are rotated back to your base currency.
          </Typography>

          <Box sx={localStyles.toggleGroup(theme)}>

          {/* Take Profit Section */}
          <Grid item>

          <FormControlLabel
              control={<Switch checked={user.isTakeProfitEnabled} onChange={(e) => dispatch(updateLocalUser({ isTakeProfitEnabled: e.target.checked }))} name="Take Profit" />}
              label="Enable Take Profit (Sell when profit margin reached) " />
          </Grid>

          <div style={styles.spacer} />


          { user.isTakeProfitEnabled && <Grid item>
              <TextField
              InputProps={{
              endAdornment: <InputAdornment position="start">%</InputAdornment>,
              }}
              type="number"
              label="Percentage"
              placeholder="Take Profit Percentage %"
              helperText="Take Profit Threshold (Sell once market price reaches percentage regardless of indicators)"
              value={user.takeProfitPercentage}
              onChange={(e: any) => dispatch(updateLocalUser({ takeProfitPercentage: e.target.value }))}/>
          </Grid> }

          {/* Sell Profit Section */}
           <Grid item>

          <FormControlLabel
              control={<Switch checked={user.sellProfitsToFiat} onChange={(e) => dispatch(updateLocalUser({ sellProfitsToFiat: e.target.checked }))} name="Sell Profit To Fiat" />}
              label="Sell Profit to a USD base (If using USDT profit will be converted to TUSD and vice versa)" />
          </Grid>
          </Box>


          <Divider sx={localStyles.divider(theme)} />



          { user.sellProfitsToFiat && <Grid item>

            <MobileStepper 
                style={{ height: 50 }}
                position="static" 
                steps={user.sellProfitsThreshold || 0} 
                variant="progress" 
                activeStep={user.currentSellProfitAmount}
                backButton={<Button>{`Current Amount: $${user.currentSellProfitAmount ? user.currentSellProfitAmount.toFixed(2) : 0} USD`}</Button>} 
                nextButton={<Button>{`Threshold: $${user.sellProfitsThreshold} USD`}</Button>}/>

            <Slider 
              value={user.sellProfitsThreshold}
              valueLabelDisplay="auto"
              min={20} 
              max={200} 
              onChange={(e, newValue) => dispatch(updateLocalUser({ sellProfitsThreshold: Number(newValue) }))}
              />

          </Grid> }

          </Card>
  )
}

const localStyles = {
  card: (theme: any) => ({
    backgroundColor: alpha(theme.palette.common.white, theme.palette.mode === "dark" ? 0.03 : 0.74),
    borderRadius: "16px",
    border: `1px solid ${alpha(theme.palette.common.white, theme.palette.mode === "dark" ? 0.08 : 0.55)}`,
    padding: 2.5,
    boxShadow: "none",
  }),
  copy: (theme: any) => ({
    mb: 2.5,
    color: alpha(theme.palette.text.primary, 0.68),
    maxWidth: 760,
  }),
  toggleGroup: (theme: any) => ({
    display: "grid",
    gap: 1,
    p: 2,
    borderRadius: "14px",
    backgroundColor: alpha(theme.palette.common.white, theme.palette.mode === "dark" ? 0.03 : 0.58),
    border: `1px solid ${alpha(theme.palette.common.white, theme.palette.mode === "dark" ? 0.06 : 0.45)}`,
  }),
  divider: (theme: any) => ({
    my: 2.5,
    borderColor: alpha(theme.palette.text.primary, 0.1),
  }),
}
